<template>
  <div
    class="my-2 rounded-lg border-1 cursor-pointer transition-all hover:shadow-md border-gray-300 hover:border-customBlue-100 bg-white">
    <div class="relative flex justify-end items-center w-full p-[10px]">
      <div v-if="getActions().length > 0"
        class="col-span-5 tablet:col-span-1 top-[5px] laptop:top-[10px] right-0 tablet:relative flex items-center justify-end gap-[5px] z-[1]">
        <div class="flex items-center gap-[10px] w-max laptop:hidden rounded-full p-[5px] bg-[#EFEFEF]/50">
          <span
            class="text-[#333333] font-poppins mobile:!text-[14px] largeDesktop:text-base largeDesktop:font-poppins inline-block ">Status:</span>
          <div>
            <p v-if="item.progress_status_slug == 'open-lead'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#BA90C6]">
              Broadcasted</p>
            <p v-else-if="item.progress_status_slug == 'contractor-confirmed'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#29C6CD]">
              Contractor Assigned</p>
            <p v-else-if="item.progress_status_slug == 'en-route'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#125B9A]">
              En Route</p>
            <p v-else-if="item.progress_status_slug == 'arrived'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#00ADEF]">
              Arrived</p>
            <p v-else-if="item.progress_status_slug == 'quote-submitted'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#8479E1]">
              Quote Submitted</p>
            <p v-else-if="item.progress_status_slug == 'checkout'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#54B435]">
              Checkout Done</p>
            <p v-else-if="item.progress_status_slug == 'close'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#686D76]">
              Close</p>
            <p v-else-if="item.progress_status_slug == 'quote-decline'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#C768FF]">
              Quote Decline</p>
            <p v-else-if="item.progress_status_slug == 'cancellation-requested'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#E8B008]">
              Cancellation Requested</p>
            <p v-else-if="item.progress_status_slug == 'cancelled'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#FE5000]">
              Cancelled</p>
            <p v-else-if="item.progress_status_slug == 'authorized'"
              class="inline-block text-center py-[1px] px-[15px] text-[14px] rounded-full mb-0 text-white bg-[#9C9BBF]">
              Authorized</p>
            <p v-else>-</p>
          </div>
        </div>
        <div ref="dropdownWrapper">
          <div class="relative flex">
            <button class="focus:outline-none" @click="toggleDropdown">
              <img src="../../assets/images/white-ellipse.svg" alt="Up Down Arrow" class="w-[32px] h-[32px]">
            </button>
            <ul v-if="isOpen"
              class="absolute top-[35px] right-0 z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-poppins py-[5px]">
              <span class="absolute -top-[10px] right-[10px] w-0 h-0
                border-l-[6px] border-l-transparent
                border-r-[6px] border-r-transparent
                border-b-[12px] border-b-white"></span>
              <li v-for="option in getActions()" :key="option" @click="select(option)"
                class="px-2 py-[5px] mx-[10px] my-[2px] rounded-md border-[1px] border-[#E5D3B7] bg-[#E5D3B7]/20 cursor-pointer text-left">
                {{ option }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="px-[10px] flex justify-between items-center col-span-5 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1 bg-[#EFEFEF]/50">
      <div>
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Job
          ID:</span>
        <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
          <router-link :to="{ name: 'workOrdersDetail', params: { id: item.appointment_id } }"
            class="cursor-pointer text-[#2459A8]" @click.stop>
            {{ $helper.isEmpty(item.job_number) ? '-' : item.job_number }}
          </router-link>
        </p>
      </div>
      <div>
        <div class="relative group">
          <!-- Info Icon -->
          <div class="rounded-full p-[5px] bg-[#fff]">
            <img src="../../assets/images/map-icon-yellow.svg" alt="Info Icon" class="w-[22px] h-[22px] cursor-pointer"
              @click.stop="toggleTooltip" />
          </div>
          <!-- Tooltip -->
          <div :class="[
            'absolute -right-[6px] top-full mt-2 w-max max-w-[320px]',
            'bg-[#2459A8] text-white text-[14px] font-roboto font-normal px-3 py-2 rounded-[10px]',
            'border-[1px] border-white shadow-[0_0_10px_0_#00000026]',
            'transition-opacity duration-200 pointer-events-none mobile:z-[99] laptop:z-[999]',
            // Desktop hover
            'md:opacity-0 md:group-hover:opacity-100 tooltip-mobile',
            // Mobile click
            isTooltipActive ? 'opacity-100' : 'opacity-0'
          ]">
            <!-- Triangle -->
            <span class="absolute -top-[12px] right-[14px] w-0 h-0
                border-l-[6px] border-l-transparent
                border-r-[6px] border-r-transparent
                border-b-[12px] border-b-[#2459A8]"></span>
            {{ item.service_address }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-[10px] relative grid grid-cols-4 tablet:grid-cols-5 laptop:grid-cols-12 largeDesktop:grid-cols-12 gap-2.5 laptop:gap-1.5 largeDesktop:gap-2.5 break-words">
      <div
        class="laptop:flex justify-between items-center mobile:hidden tablet:col-span-2 laptop:col-span-2 largeDesktop:col-span-1 bg-[#EFEFEF]/50">
        <div>
          <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Job
            ID:</span>
          <p class="m-0 font-poppins text-[16px] tablet:text-[14px] laptop:text-[16px] font-normal">
            {{ $helper.isEmpty(item.job_number) ? '-' : item.job_number }}
          </p>
        </div>
        <div>
          <div class="relative group">
            <!-- Info Icon -->
            <img src="../../assets/images/plan-info.svg" alt="Info Icon" class="w-[22px] h-[22px] cursor-pointer"
              @click.stop="toggleTooltip" />

            <!-- Tooltip -->
            <div :class="[
              'absolute -right-[10px] top-full mt-2 w-max max-w-[320px]',
              'bg-[#2459A8] text-white text-[14px] font-roboto font-normal px-3 py-2 rounded-[10px]',
              'border-[1px] border-white shadow-[0_0_10px_0_#00000026]',
              'transition-opacity duration-200 pointer-events-none z-[999]',
              // Desktop hover
              'md:opacity-0 md:group-hover:opacity-100',
              // Mobile click
              isTooltipActive === true ? 'opacity-100' : 'opacity-0'
            ]">
              <!-- Triangle -->
              <span class="absolute -top-[6px] right-[14px] w-0 h-0
                border-l-[6px] border-l-transparent
                border-r-[6px] border-r-transparent
                border-b-[6px] border-b-[#2459A8]"></span>

              Choose the date when the incident occurred
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-2 tablet:col-span-2 laptop:col-span-2 largeDesktop:col-span-3 relative group">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">
          Technician:
        </span>
        <p class="m-0 font-poppins text-[14px] laptop:text-[16px] font-normal block">
          {{ item.assignee_name }}
          <!-- John Doe -->
        </p>
      </div>
      <div class="col-span-2 tablet:col-span-2 laptop:col-span-2 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Trade:</span>
        <p class="m-0 font-poppins text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.trade_name) ? '-' : item.trade_name }}
        </p>
      </div>
      <div class="col-span-4 tablet:col-span-1 laptop:col-span-2 largeDesktop:col-span-1">
        <span
          class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Service:</span>
        <p class="m-0 font-poppins text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.service_name) ? '-' : item.service_name }}
        </p>
      </div>
      <div class="col-span-2 tablet:col-span-2 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Claim
          Requested:</span>
        <p class="m-0 font-poppins text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.requested_date_time) ? '-' : $helper.formatDateTime(item.requested_date_time) }}
        </p>
      </div>
      <div class="col-span-2 tablet:col-span-2 laptop:col-span-1 largeDesktop:col-span-1">
        <span class="text-[#999999] font-poppins mobile:!text-[14px] largeDesktop:text-base inline-block">Visit Date &
          Time:</span>
        <p class="m-0 font-poppins text-[14px] laptop:text-[16px] font-normal">
          {{ $helper.isEmpty(item.appointment_date_time) ? '-' : $helper.formatDateTime(item.appointment_date_time) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
 props: {
    item: Object,
    index: Number,
    isTooltipActive: Boolean
  },
  components: {
  },
  data() {
    return {
      isOpen: false,
      activeTooltip: false
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('click', this.closeTooltip)
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('click', this.closeTooltip)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getActions() {
      let res = ["Details"]
      if (!(this.item.appointment_status > 1)) {
        res.push("Cancel")
      }
      // if ((this.item.can_reschedule == 1)) {
      //     res.push("Reschedule Appointment")
      // }
      return res
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    select(value) {
      // this.selected = value;
      this.isOpen = false;
      this.$emit('update', this.item, value); // emit change if needed
    },

    getShortPlanName(name) {
      if (this.$helper.isEmpty(name)) return '-';
      return name.length > 30 ? name.substring(0, 30) + '...' : name;
    },

    handleClickOutside(event) {
      const tooltipDiv = this.$el.querySelector('.tooltip-mobile');

      // agar click tooltip ya icon ke andar nahi hai
      if (
        this.activeTooltip &&
        tooltipDiv &&
        !tooltipDiv.contains(event.target) &&
        !event.target.closest('img') // tooltip icon
      ) {
        this.closeTooltip();
      }
      if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },
    toggleTooltip() {
      if (window.innerWidth < 1275) {
        this.$emit('tooltip-toggled', this.index);
      }
    },
    closeTooltip() {
      this.$emit('tooltip-toggled', null);
    },

    handleScroll() {
      // Close tooltip on scroll for mobile/tablet
      if (window.innerWidth < 1275 && this.activeTooltip) {
        this.closeTooltip()
      }
    },

    idClicked() {
      alert("hi")
    }
  }
};
</script>